import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'SignInButton' })({
    root: {
        padding: '14px 16px',
        borderRadius: 12,
        background: '#232323 !important',
        color: '#fff',
        fontSize: 16,
        fontWeight: 500,
        lineHeight: '16px',
        boxSizing: 'border-box'
    }
});
